import LeetcodeFeatured from "./Card.LeetcodeFeatured";

export default {
  LeetcodeFeatured,
};
